import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    data: [],
    oneData: null,
};

export const enquireSlice = createSlice({
    name: 'enquire',
    initialState,
    reducers: {
        getEnquire: (state) => {
            state.loading = true;
        },
        removeEnquire: (state) => {
            state.loading = true;
        },
        updateEnquire: (state) => {
            state.loading = true;
        },
        getOneEnquire: (state) => {
            state.loading = true;
        },
        successEnquire: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        successOneEnquire: (state, action) => {
            state.loading = false;
            state.oneData = action.payload;
        },
        failedEnquire: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { 
    getEnquire, 
    removeEnquire, 
    updateEnquire, 
    getOneEnquire,
    successEnquire, 
    successOneEnquire,
    failedEnquire 
} = enquireSlice.actions;

export default enquireSlice.reducer;